module.exports = __webpack_public_path__ + "img/0Q3A2626_L_Black.c1cd6ccb.jpg";